import { Label } from '@design-system/label';
import { CurrencyField } from '@shared/fields/currency-field';
import { Textfield } from '@shared/fields/text-field';
import type { TBankAccount } from '@shared/types/bank-account';
import { useFormikContext } from 'formik';
import { useEditBankLogo } from '../services/edit-bank-logo';
import {
  Upload,
  UploadArea,
  UploadButton,
  UploadError,
  UploadInputDisplay,
  UploadTrigger,
} from '@design-system/upload';
import { MAX_INTERVIEWER_IMAGE_SIZE } from '@shared/forms/interviewer';

const FinancialDetailsEdit = () => {
  const { values, setFieldValue } = useFormikContext<TBankAccount>();
  const { mutateAsync } = useEditBankLogo();

  const handleFileUpload = (file: File | null) => {
    const formData = new FormData();
    if (file) {
      const modifiedAvatar = new File([file], file.name.substring(0, 99), {
        type: file.type,
      });
      formData.append('logo', modifiedAvatar);
      if (values.id) mutateAsync({ formData, id: values.id });
      setFieldValue('logo', file);
    }
  };

  return (
    <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
      <p className='text-gray-600 font-medium text-sm mb-2'>
        Financial Details
      </p>
      <div className='flex items-center gap-2'>
        <div className='w-full'>
          <Textfield
            name='bank_name'
            type='text'
            placeholder='ex: CIB'
            label='Bank Name'
          />
        </div>
        <div className='w-full'>
          <Upload
            maxSize={MAX_INTERVIEWER_IMAGE_SIZE}
            onFileChange={handleFileUpload}
          >
            <UploadArea>
              <Label>Logo</Label>
              <UploadTrigger className='flex-1 flex h-[50px] w-full'>
                <UploadButton />
                <UploadInputDisplay
                  placeholder={
                    typeof values.logo === 'string'
                      ? values.logo.split('/').pop()
                      : ''
                  }
                />
              </UploadTrigger>
            </UploadArea>
            <UploadError />
          </Upload>
        </div>
      </div>

      <Textfield
        name='beneficiary_name'
        type='text'
        placeholder='ex: Ahmed'
        label='Beneficiary Name'
      />
      <Textfield
        name='account_number'
        type='number'
        placeholder='Enter Account Number'
        label='Account Number'
      />
      <div>
        <Label>Currency</Label>
        <CurrencyField selectName={'currency'} />
      </div>
      <Textfield
        name='iban'
        type='text'
        placeholder='Enter Routing Number/IBAN'
        label='Routing Number/IBAN'
      />
      <Textfield
        name='swift_code'
        type='text'
        placeholder='ex: 124356'
        label='Swift'
      />
    </div>
  );
};

export default FinancialDetailsEdit;
